<ng-template #customerTemp let-r="result" let-t="term">
  <div>
    <ngb-highlight
      [result]="
        r.CustomerTypeId
          ? r.CustomerTypeId == 1
            ? r.FirstName + ' ' + r.LastName
            : r.BusinessName
          : r
      "
      [term]="t"
    ></ngb-highlight>
  </div>
</ng-template>
<div class="input-container">
  <input
    id="customerSearch"
    [disabled]="disabled"
    type="search"
    autocomplete="off"
    class="form-control"
    [inputFormatter]="customerFormatter"
    [resultFormatter]="customerFormatter"
    [ngClass]="{ 'is-invalid': required && !customerInfo }"
    [ngModel]="customerInfo"
    (ngModelChange)="change($event)"
    placeholder="Search Customer"
    [ngbTypeahead]="searchCustomer"
    [resultTemplate]="customerTemp"
    (selectItem)="onSelect($event.item)"
    name="customerInfo"
  />
  <div class="dropdown-item-no-records" *ngIf="showNoRecord">
    <span>No customer found</span>
  </div>
</div>
